module.exports = __webpack_public_path__ + "img/img3.0792db11.jpg";